export const REGISTER_FORM_FIELDS = {
    cell: { value: null, error: null },
    email: { value: null, error: null },
    address: { value: null, error: null },
    country: { value: null, error: null },
    lastName: { value: null, error: null },
    password: { value: null, error: null },
    firstName: { value: null, error: null },
    retypePassword: { value: null, error: null },
};

export const OPTIONAL_FORM_FIELDS = ['cell', 'address'];
export const RECAPTCHA_SITE_KEY = '6LdJdOcUAAAAABfukXQuNi3kpeSzjdEXN6LGOKxy';

export const ADVANCED_SEARCH_FORM = {
    questionMaxLength: 300,
    titleMaxLength: 300,
    answerMaxLength: 300,
};
